export const styles = theme => ({
    root : {
        display: "grid",
        padding: "1px",
        marginLeft:'2%',
        marginRight: '2%',
        borderRadius: "5px",
        backgroundColor: "#e8eaf5",
    },
    container: {
        overflow: "auto",
        maxWidth: "100%",
        backgroundColor: "#e8eaf5",
        "@media print":{
            display: 'none',
        },
        "& >div": {
            "& >div": {
                "& >div": {
                    "& >div": {
                        "& >div": {            
                            "& >table": {
                                "& >thead":{
                                    "& > tr":{
                                        "& >th":{
                                            textAlign:'center',
                                            fontSize: '1em',
                                            padding: 1,
                                            "& >span":{
                                                "& >div":{
                                                    fontWeight: 'bold',
                                                }
                                            }
                                        }
                                    }
                                },
                                "& >tbody": {
                                    "& >tr": {
                                        "& >td": {
                                            padding: 1,
                                            textAlign:'center',
                                            fontSize:'0.8rem',
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        },
    },
	appBar: {
		backgroundColor: '#01579B',
	},    
	title: {
		flexGrow: 1,
	},	
	buttonUpdate:{
		color: 'white',
	}        
});

